export const Institutions = {
  filters: [
    { id: 1, value: 'Argonne National Laboratory' },
    { id: 2, value: 'Idaho National Laboratory' },
    { id: 3, value: 'Lawrence Berkeley National Laboratory' },
    { id: 4, value: 'Lawrence Livermore National Laboratory' },
    { id: 5, value: 'Los Alamos National Laboratory' },
    { id: 6, value: 'National Renewable Energy Laboratory' },
    { id: 7, value: 'Oak Ridge National Laboratory' },
    { id: 8, value: 'Pacific NorthWest National Laboratory' },
    { id: 9, value: 'Sandia National Laboratories' },
    { id: 10, value: 'Electric Power Research Institute' },
    { id: 11, value: 'HOMER<sup>®</sup> Energy' },
    { id: 12, value: 'DNV' },
    { id: 13, value: 'XENDEE Corporation' },
  ]
};

export const Category = {
  info: [
    {
      id: 1,
      title: 'Energy Storage Technology',
      description:
        'Evaluating technical merits (e.g. cost, efficiencies, lifetime, and duration) of different energy storage technologies considering various aspects such as material, structure, chemical process, and manufacturing. Optimization and evaluation for the grid and end-user applications are not provided.'
    },
    {
      id: 2,
      title: 'Price-taker Valuation',
      description:
        'Model, optimize, and evaluate energy storage for a broad range of grid and end-user applications and assist project-level decision-making. It is assumed that the energy storage systems are not large enough to affect the prices of different services. Built-in databases for load and prices and financial analysis engines are also available in some of these tools.'
    },
    {
      id: 3,
      title: 'Production Cost Modeling',
      description:
        'Simulate and analyze the economic operation of power systems for periods ranging from days to years with different supply, demand, and transmission models. The outputs from these tools such as operation cost, prices, and dispatch results can be used in the economic assessment of energy storage systems that are large enough to affect the operation of other resources and service prices.'
    },
    {
      id: 4,
      title: 'Supporting Tool',
      description:
        'Not dedicated to energy storage but could be leveraged for energy storage analyses by enabling users to simulate power system operation, capture interdependency among different systems, analyze the supply chain of key materials, quantify financial viability with market evolution, etc.'
    }
  ],
  filters: [
    { id: 1, value: 'Energy Storage Technology' },
    { id: 2, value: 'Price-taker Valuation' },
    { id: 4, value: 'Production Cost Modeling' },
    { id: 6, value: 'Supporting Tool' }
  ]
};

export const Type = {
  filters: [
    { id: 1, value: 'Agent-based' },
    { id: 2, value: 'Engineering' },
    { id: 3, value: 'Financial' },
    { id: 4, value: 'Optimization' },
    { id: 5, value: 'Other' },
    { id: 6, value: 'Simulation' },
    { id: 7, value: 'Techno-economic' }
  ]
};

export const EnergySector = {
  filters: [
    { id: 1, value: 'Transmission System' },
    { id: 2, value: 'Distribution System' },
    { id: 3, value: 'Generation System' },
    { id: 4, value: 'Demand/Customer Side' },
    { id: 5, value: 'Device-level' },
    { id: 6, value: 'Crosscutting' }
  ]
};

export const Availability = {
  filters: [
    { id: 1, value: 'DOE/Lab-hosted Web Link' },
    { id: 2, value: 'Public Domain' },
    { id: 3, value: 'Open-source License' },
    { id: 4, value: 'No-cost Proprietary License' },
    { id: 5, value: 'Fee-based License' },
    { id: 6, value: 'Official Use Only' },
    { id: 10, value: 'Unknown' }
  ]
};
